import { Button } from "@admin/components/atoms/Button";
import { Modal, ModalProps } from "@admin/components/atoms/Modal";
import { dateToISO,Shift, updateShift } from "@enos-monorepo/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface EndShiftModalProps extends ModalProps {
  shift?: Shift;
  locationId: string;
  companyId: string;
}
export function EndShiftModal({
  shift,
  locationId,
  companyId,
  ...props
}: EndShiftModalProps) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const addShiftMutation = useMutation({
    mutationFn: updateShift,
    onSuccess: () => {
      toast.success(t("shift.The shift has been ended"));
      queryClient.invalidateQueries({ queryKey: ["shifts", locationId] });
      props.onClose?.();
    },
    onError: () => {
      toast.error(t("shift.Unable to end the shift"));
    },
  });
  const onSubmit = () => {
    // when user has not planned start and end date (For ex: quick shift)
    let payload;
    !shift?.plannedEndDate && !shift?.plannedEndDate
      ? (payload = {
          id: shift?.id ?? "",
          companyId: companyId,
          companyLocationId: locationId ?? "",
          userId: shift?.userId ?? "",
          workStartDate: shift?.workStartDate ?? "",
          workEndDate: dateToISO(new Date()),
        })
      : (payload = {
          id: shift?.id ?? "",
          companyId: companyId,
          companyLocationId: locationId ?? "",
          userId: shift?.userId ?? "",
          workStartDate: shift?.workStartDate ?? "",
          workEndDate: dateToISO(new Date()),
          plannedStartDate: shift?.plannedStartDate ?? "",
          plannedEndDate: shift?.plannedEndDate ?? "",
        });
    addShiftMutation.mutate(payload);
  };
  return (
    <Modal
      title={`${t("shift.End Shift")}: ${shift?.firstName + " " + shift?.lastName}`}
      {...props}
      actionButtons={
        <>
          <Button variant="secondary" type="button" onClick={props?.onClose}>
            {t("common.Discard")}
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={addShiftMutation.isPending}
            loading={addShiftMutation.isPending}
            onClick={onSubmit}
          >
            {t("shift.End Shift")}
          </Button>
        </>
      }
    >
      <form>
        <div>
          {shift?.firstName + " " + shift?.lastName}&apos;{" "}
          {t("shift.shift is currently active. Are you sure to end the shift?")}
        </div>
      </form>
    </Modal>
  );
}
